module.exports = __webpack_public_path__ + "img/text.750593f4.svg";